import { AnyAction } from '@reduxjs/toolkit'

import { CHANGE_CURRENT_SPACE } from '@/store/actionTypes'

import {
  FETCH_SPACE_MEMBERS_BY_NOT_ROLE_SUCCESS,
  FETCH_SPACE_MEMBERS_BY_ROLE_SUCCESS,
  RESET_SPACE_MEMBERS_ROLES_PAGINATION_STATE
} from './actionTypes'

type SpaceMembersRolesPageState = {
  direction: string
  searchResults: string[]
  selectedRoleGuid: unknown
  sortBy: string
  startIndex: number
  totalItemsCount: number
  users: string[]
  currentPage?: number
}

const initialState: SpaceMembersRolesPageState = {
  direction: 'ascending',
  searchResults: [],
  selectedRoleGuid: null,
  sortBy: 'displayName',
  startIndex: 1,
  totalItemsCount: 0,
  users: []
}

export default (state = initialState, action: AnyAction): SpaceMembersRolesPageState => {
  switch (action.type) {
    case FETCH_SPACE_MEMBERS_BY_ROLE_SUCCESS: {
      return {
        ...state,
        users: action.response.resources.map(({ id }: { id: string }) => id),
        totalItemsCount: action.response.totalResults,
        startIndex: action.response.startIndex,
        currentPage: action.response.currentPage,
        selectedRoleGuid: action.roleGuid,
        sortBy: action.sortBy,
        direction: action.direction
      }
    }
    case FETCH_SPACE_MEMBERS_BY_NOT_ROLE_SUCCESS: {
      return {
        ...state,
        searchResults: action.response.resources.map(({ id }: { id: string }) => id)
      }
    }
    case RESET_SPACE_MEMBERS_ROLES_PAGINATION_STATE:
    case CHANGE_CURRENT_SPACE: {
      return { ...state, ...initialState }
    }
    default: {
      return state
    }
  }
}
